import React, {useState, useEffect} from 'react'
import Modal from 'components/utils/Modal'
import SearchBar from 'components/utils/SearchBar'

import { formatDateYMD, formatDateTime, filterData } from 'scripts/common'

const Library = (props) => {

  const [fetchedData, setFetchedData] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const fetchData = () => {

    fetch('/api/selectLibrary', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }
    })
    .then(res=>res.json())
    .then(
      (result) => {
        //console.log('result: ' + result)
        setFetchedData(result.map(data => (
          {...data,
            entrytime: formatDateTime(data.entrytime),
            modtime: formatDateTime(data.modtime),
            jobDate: formatDateYMD(data.jobDate),
            libraryId: data.id
          }
        )))        
      },
      (error) => {
        console.log('Error: selectLibrary --> ' + error)
      }
    )

  }

  useEffect(() => {
    fetchData()
  }, [])

  const search = (e) => setSearchValue(e.target.value)

  const clearSearch = () => {
    document.getElementById('searchInput').value = ''
    setSearchValue('')
  }

  let listOfData = fetchedData.map(data => {

    let filter = filterData(data, searchValue)

    if (filter) {
      return (
        <tr key={data.id.toString()} onClick={props.selectLibrary}>          
          <td style={{display: 'none'}}>{data.latitude}</td>
          <td style={{display: 'none'}}>{data.longitude}</td>
          <td>{data.id}</td>
          <td>{data.description}</td>          
          <td>{data.company}</td>
          <td>{data.jobDate}</td>
          <td>{data.address}, {data.city}</td>
        </tr>
      )
    }

  })

  let content = (
    <div style={{display: 'flex', flexFlow: 'column', height: '100%'}}>

      <SearchBar search={search} searchValue={searchValue} clearSearch={clearSearch} />

      <div style={{textAlign: 'center'}}>
        <div style={{
          border: '2px solid tomato',
          borderRadius: 5,
          color: 'tomato',
          cursor: 'pointer',
          padding: 5,
          margin: 10
        }} onClick={props.clearJob}>Clear Library Record
        </div>
      </div>

      <>

        <div style={{margin: 10, flex: '1', overflow: 'auto'}}>

          <div style={{textAlign: 'center'}}>

            <div style={{display: 'inline-block'}}>

              <table>

                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Desc</th>
                    <th>Company</th>
                    <th>Date</th>
                    <th>Address</th>
                  </tr>
                </thead>

                <tbody>
                  {listOfData}
                </tbody>

              </table>

            </div>

          </div>

        </div>

      </>

    </div>
  )

  return <Modal content={content} close={props.close} />
}

export default Library
